import { FaStar } from "react-icons/fa6";

export default function StarIcon({ size, color = "#E63946" }) {
    return <FaStar size={size} color={color} />;
}